/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planchangescheduled2Inputs */

const en_planchangescheduled2 = /** @type {(inputs: Planchangescheduled2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your plan change is scheduled.`)
};

const de_planchangescheduled2 = /** @type {(inputs: Planchangescheduled2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Planwechsel wurde vorgemerkt.`)
};

/**
* | output |
* | --- |
* | "Your plan change is scheduled." |
*
* @param {Planchangescheduled2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const planchangescheduled2 = /** @type {((inputs?: Planchangescheduled2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planchangescheduled2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_planchangescheduled2(inputs)
	return de_planchangescheduled2(inputs)
});
export { planchangescheduled2 as "planChangeScheduled" }